import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import authService from '../services/authService';
import './NewsletterSignup.css';

const NewsletterSignup = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Basic validation
    if (!email) {
      setError('Email is required');
      return;
    }
    
    if (!/\S+@\S+\.\S+/.test(email)) {
      setError('Please enter a valid email address');
      return;
    }
    
    setIsSubmitting(true);
    setError(null);
    setMessage(null);
    
    try {
      const response = await authService.subscribeGuestToNewsletter(email);
      setMessage(response.message || 'Thanks for subscribing!');
      setEmail(''); // Clear form after successful submission
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to subscribe. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="newsletter-signup">
      <div className="newsletter-content">
        <h3>Stay Updated!</h3>
        <p>Subscribe to our newsletter for updates on new card releases, trading tips, and exclusive offers.</p>
        
        {message ? (
          <div className="success-message">
            <p>{message}</p>
            <p>Would you like to <Link to="/register">create an account</Link> to track your collection?</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && <div className="error-message">{error}</div>}
            
            <div className="newsletter-form-group">
              <input
                type="email"
                placeholder="Your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isSubmitting}
              />
              <button 
                type="submit" 
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Subscribing...' : 'Subscribe'}
              </button>
            </div>
            
            <div className="register-prompt">
              Already a collector? <Link to="/register">Create an account</Link> to manage your collection.
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default NewsletterSignup;